import publicAxios from './PublicAxios';

/**
 * Contratação do Colmeia pelo site (rota pública /signup). Nenhuma chamada usa login.
 */

// Planos que a equipe liberou para contratação pelo site.
export const getSignupPlans = () => publicAxios.get('/api/saas-signup/plans');

// Plano do link /signup?plan={uuid}, do site ou do link exclusivo. O exclusivo não está na
// lista pública, então a página só o conhece por aqui; 404 quando o plano não está liberado.
export const getSignupPlan = (uuid) => publicAxios.get(`/api/saas-signup/plans/${encodeURIComponent(uuid)}`);

// Dados públicos do CNPJ para preencher o formulário; o backend limita consultas por IP.
export const lookupSignupCnpj = (cnpj) => publicAxios.get(`/api/saas-signup/cnpj/${cnpj}`);

// Cria empresa, administrador e assinatura; devolve o link da primeira fatura.
export const submitSignup = (payload) => publicAxios.post('/api/saas-signup', payload);

/**
 * Endereço da contratação de um plano: o link dos botões do site e o link exclusivo que a
 * equipe envia ao cliente. Fica aqui, junto das chamadas da contratação, para o formulário e a
 * lista de planos montarem o mesmo endereço.
 */
export const buildSignupUrl = (uuid) =>
    `${(process.env.REACT_APP_BASE_URL || window.location.origin).replace(/\/$/, '')}/signup?plan=${encodeURIComponent(uuid)}`;
